import {
  ADD__COST__PRICE__SETTING_FAILURE,
  ADD__COST__PRICE__SETTING_REQUEST,
  ADD__COST__PRICE__SETTING_RESET,
  ADD__COST__PRICE__SETTING_SUCCESS,
  ADD_CAD__MARKER_FAILURE,
  ADD_CAD__MARKER_REQUEST,
  ADD_CAD__MARKER_RESET,
  ADD_CAD__MARKER_SUCCESS,
  ADD_COLOR_PREFIX_FAILURE,
  ADD_COLOR_PREFIX_REQUEST,
  ADD_COLOR_PREFIX_SUCCESS,
  ADD_COLOR_SUFFIX_FAILURE,
  ADD_COLOR_SUFFIX_REQUEST,
  ADD_COLOR_SUFFIX_SUCCESS,
  ADD_COST__GROUP_FAILURE,
  ADD_COST__GROUP_REQUEST,
  ADD_COST__GROUP_RESET,
  ADD_COST__GROUP_SUCCESS,
  ADD_REMARK_FAILURE,
  ADD_REMARK_REQUEST,
  ADD_REMARK_RESET,
  ADD_REMARK_SUCCESS,
  ADD_STYLE_PREFIX_FAILURE,
  ADD_STYLE_PREFIX_REQUEST,
  ADD_STYLE_PREFIX_SUCCESS,
  ADD_STYLE_SUFFIX_FAILURE,
  ADD_STYLE_SUFFIX_REQUEST,
  ADD_STYLE_SUFFIX_SUCCESS,
  APPROVE_REJECT_FAILURE,
  APPROVE_REJECT_REQUEST,
  APPROVE_REJECT_RESET,
  APPROVE_REJECT_SUCCESS,
  CLEAR_ERRORS,
  CREATE_MASTER_GROUP_DATA_FAILURE,
  CREATE_MASTER_GROUP_DATA_REQUEST,
  CREATE_MASTER_GROUP_DATA_RESET,
  CREATE_MASTER_GROUP_DATA_SUCCESS,
  CREATE_SESSION_FAILURE,
  CREATE_SESSION_REQUEST,
  CREATE_SESSION_SUCCESS,
  DELETE__COST__GROUP_FAILURE,
  DELETE__COST__GROUP_REQUEST,
  DELETE__COST__GROUP_RESET,
  DELETE__COST__GROUP_SUCCESS,
  EXPORT_TEMPLATE_FAILURE,
  EXPORT_TEMPLATE_REQUEST,
  EXPORT_TEMPLATE_SUCCESS,
  GET__COST__GROUP__SUMMARY_FAILURE,
  GET__COST__GROUP__SUMMARY_REQUEST,
  GET__COST__GROUP__SUMMARY_SUCCESS,
  GET__COST__PRICE__CHANGE__LOG_FAILURE,
  GET__COST__PRICE__CHANGE__LOG_REQUEST,
  GET__COST__PRICE__CHANGE__LOG_SUCCESS,
  GET__COST__PRICE__SETTING_FAILURE,
  GET__COST__PRICE__SETTING_REQUEST,
  GET__COST__PRICE__SETTING_SUCCESS,
  GET__COST_GROUP_ARRAY_FAILURE,
  GET__COST_GROUP_ARRAY_REQUEST,
  GET__COST_GROUP_ARRAY_SUCCESS,
  GET__LISTING_QUALITY_RATING_FAILURE,
  GET__LISTING_QUALITY_RATING_REQUEST,
  GET__LISTING_QUALITY_RATING_SUCCESS,
  GET__OLD__SKU__LIST_FAILURE,
  GET__OLD__SKU__LIST_REQUEST,
  GET__OLD__SKU__LIST_SUCCESS,
  GET__PORTAL_LIST__SUMMARY__HISTORY_FAILURE,
  GET__PORTAL_LIST__SUMMARY__HISTORY_REQUEST,
  GET__PORTAL_LIST__SUMMARY__HISTORY_SUCCESS,
  GET__PRICE__COMPONENT_FAILURE,
  GET__PRICE__COMPONENT_REQUEST,
  GET__PRICE__COMPONENT_SUCCESS,
  GET__SITE__CODES__INVENTORY_FAILURE,
  GET__SITE__CODES__INVENTORY_REQUEST,
  GET__SITE__CODES__INVENTORY_SUCCESS,
  GET_CATEGORIES_FAILURE,
  GET_CATEGORIES_REQUEST,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORY_FAILURE,
  GET_CATEGORY_REQUEST,
  GET_CATEGORY_SUCCESS,
  GET_COLOR_PREFIX_FAILURE,
  GET_COLOR_PREFIX_REQUEST,
  GET_COLOR_PREFIX_SUCCESS,
  GET_COLOR_SUFFIX_FAILURE,
  GET_COLOR_SUFFIX_REQUEST,
  GET_COLOR_SUFFIX_SUCCESS,
  GET_CONSUMPTION_PRICE_HISTORY_FAILURE,
  GET_CONSUMPTION_PRICE_HISTORY_REQUEST,
  GET_CONSUMPTION_PRICE_HISTORY_SUCCESS,
  GET_DROPDOWN_LIST_MASTER_GROUP_FAILURE,
  GET_DROPDOWN_LIST_MASTER_GROUP_REQUEST,
  GET_DROPDOWN_LIST_MASTER_GROUP_SUCCESS,
  GET_MASTER__GROUP_DATA_FAILURE,
  GET_MASTER__GROUP_DATA_REQUEST,
  GET_MASTER__GROUP_DATA_SUCCESS,
  GET_MASTER_PRODUCT_GROUP_LIST_FAILURE,
  GET_MASTER_PRODUCT_GROUP_LIST_REQUEST,
  GET_MASTER_PRODUCT_GROUP_LIST_SUCCESS,
  GET_PARTY_ACCOUNT_LIST_FAILURE,
  GET_PARTY_ACCOUNT_LIST_REQUEST,
  GET_PARTY_ACCOUNT_LIST_SUCCESS,
  GET_PARTY_LIST_FAILURE,
  GET_PARTY_LIST_REQUEST,
  GET_PARTY_LIST_SUCCESS,
  GET_PHOTOSHOOT_FAILURE,
  GET_PHOTOSHOOT_REQUEST,
  GET_PHOTOSHOOT_SUCCESS,
  GET_PRICE_BAND_FAILURE,
  GET_PRICE_BAND_REQUEST,
  GET_PRICE_BAND_SUCCESS,
  GET_PRICE_COMPONENT_FOR__APPROVE_REJECT_FAILURE,
  GET_PRICE_COMPONENT_FOR__APPROVE_REJECT_REQUEST,
  GET_PRICE_COMPONENT_FOR__APPROVE_REJECT_SUCCESS,
  GET_PRODUCT__GROUP__DETAILS_FAILURE,
  GET_PRODUCT__GROUP__DETAILS_REQUEST,
  GET_PRODUCT__GROUP__DETAILS_SUCCESS,
  GET_PRODUCT__STYLE__COLOR_FAILURE,
  GET_PRODUCT__STYLE__COLOR_REQUEST,
  GET_PRODUCT__STYLE__COLOR_SUCCESS,
  GET_PRODUCT_GROUPS_FAILURE,
  GET_PRODUCT_GROUPS_REQUEST,
  GET_PRODUCT_GROUPS_SUCCESS,
  GET_REMARK_FAILURE,
  GET_REMARK_REQUEST,
  GET_REMARK_SUCCESS,
  GET_SESSION_FAILURE,
  GET_SESSION_REQUEST,
  GET_SESSION_SUCCESS,
  GET_SIZES_FAILURE,
  GET_SIZES_REQUEST,
  GET_SIZES_SUCCESS,
  GET_STYLE_COLOR_FAILURE,
  GET_STYLE_COLOR_REQUEST,
  GET_STYLE_COLOR_SUCCESS,
  GET_STYLE_PREFIX_FAILURE,
  GET_STYLE_PREFIX_REQUEST,
  GET_STYLE_PREFIX_SUCCESS,
  GET_STYLE_SUFFIX_FAILURE,
  GET_STYLE_SUFFIX_REQUEST,
  GET_STYLE_SUFFIX_SUCCESS,
  GET_SUB_GROUP_COST_SUMMARY_FAILURE,
  GET_SUB_GROUP_COST_SUMMARY_REQUEST,
  GET_SUB_GROUP_COST_SUMMARY_SUCCESS,
  GET_USER__LIST_FAILURE,
  GET_USER__LIST_REQUEST,
  GET_USER__LIST_SUCCESS,
  PREPARE_FOR_EXPORT_FAILURE,
  PREPARE_FOR_EXPORT_REQUEST,
  PREPARE_FOR_EXPORT_STEP_FAILURE,
  PREPARE_FOR_EXPORT_STEP_REQUEST,
  PREPARE_FOR_EXPORT_STEP_SUCCESS,
  PREPARE_FOR_EXPORT_SUCCESS,
  SAVE_PRICE_BAND_FAILURE,
  SAVE_PRICE_BAND_REQUEST,
  SAVE_PRICE_BAND_RESET,
  SAVE_PRICE_BAND_SUCCESS,
  SUBMIT_DIRECT_IMPORT_FAILURE,
  SUBMIT_DIRECT_IMPORT_REQUEST,
  SUBMIT_DIRECT_IMPORT_SUCCESS,
  UPDATE__COST__PRICE__DETAILS_FAILURE,
  UPDATE__COST__PRICE__DETAILS_REQUEST,
  UPDATE__COST__PRICE__DETAILS_RESET,
  UPDATE__COST__PRICE__DETAILS_SUCCESS,
  UPDATE_FOR_EXPORT_STEP_FAILURE,
  UPDATE_FOR_EXPORT_STEP_REQUEST,
  UPDATE_FOR_EXPORT_STEP_SUCCESS,
  VIEW_CAD_MARKER_FAILURE,
  VIEW_CAD_MARKER_REQUEST,
  VIEW_CAD_MARKER_SUCCESS,
} from "../Constants/PortalList.constants";

// Dropdown Data Reducers
export const DropdownDataReducers = (
  state = {
    party: {},
    partyAccount: {},
    categories: {},
    productGroups: {},
    styleColor: {},
  },
  action
) => {
  switch (action.type) {
    case GET_PARTY_LIST_REQUEST:
    case GET_PARTY_ACCOUNT_LIST_REQUEST:
    case GET_CATEGORY_REQUEST:
    case GET_PRODUCT_GROUPS_REQUEST:
    case GET_STYLE_COLOR_REQUEST:
      return {
        loading: true,
      };
    case GET_PARTY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        party: action.payload,
      };
    case GET_PARTY_ACCOUNT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        partyAccount: action.payload,
      };
    case GET_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload,
      };
    case GET_PRODUCT_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        productGroups: action.payload,
      };
    case GET_STYLE_COLOR_SUCCESS:
      return {
        ...state,
        loading: false,
        styleColor: action.payload,
      };
    case GET_PARTY_LIST_FAILURE:
    case GET_PARTY_ACCOUNT_LIST_FAILURE:
    case GET_CATEGORY_FAILURE:
    case GET_PRODUCT_GROUPS_FAILURE:
    case GET_STYLE_COLOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Submit Direct Import Reducers
export const SubmitDirectImportReducers = (
  state = {
    submitDirectImport: {},
  },
  action
) => {
  switch (action.type) {
    case SUBMIT_DIRECT_IMPORT_REQUEST:
      return {
        loading: true,
      };
    case SUBMIT_DIRECT_IMPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        submitDirectImport: action.payload,
      };
    case SUBMIT_DIRECT_IMPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Prepare For Export Reducers
export const PrepareForExportReducers = (
  state = {
    export_data: {},
  },
  action
) => {
  switch (action.type) {
    case PREPARE_FOR_EXPORT_REQUEST:
      return {
        loading: true,
      };
    case PREPARE_FOR_EXPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        export_data: action.payload,
      };
    case PREPARE_FOR_EXPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Prepare For Export Step Reducers
export const PrepareForExportStepReducers = (
  state = {
    export_data_step: {},
  },
  action
) => {
  switch (action.type) {
    case PREPARE_FOR_EXPORT_STEP_REQUEST:
      return {
        loading: true,
      };
    case PREPARE_FOR_EXPORT_STEP_SUCCESS:
      return {
        ...state,
        loading: false,
        export_data_step: action.payload,
      };
    case PREPARE_FOR_EXPORT_STEP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get style Prefix Reducers
export const GetStylePrefixReducers = (
  state = {
    style_prefix: {},
  },
  action
) => {
  switch (action.type) {
    case GET_STYLE_PREFIX_REQUEST:
      return {
        loading: true,
      };
    case GET_STYLE_PREFIX_SUCCESS:
      return {
        ...state,
        loading: false,
        style_prefix: action.payload,
      };
    case GET_STYLE_PREFIX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Style Suffix Reducers
export const GetStyleSuffixReducers = (
  state = {
    style_suffix: {},
  },
  action
) => {
  switch (action.type) {
    case GET_STYLE_SUFFIX_REQUEST:
      return {
        loading: true,
      };
    case GET_STYLE_SUFFIX_SUCCESS:
      return {
        ...state,
        loading: false,
        style_suffix: action.payload,
      };
    case GET_STYLE_SUFFIX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Color Suffix Reducers
export const GetColorSuffixReducers = (
  state = {
    color_suffix: {},
  },
  action
) => {
  switch (action.type) {
    case GET_COLOR_SUFFIX_REQUEST:
      return {
        loading: true,
      };
    case GET_COLOR_SUFFIX_SUCCESS:
      return {
        ...state,
        loading: false,
        color_suffix: action.payload,
      };
    case GET_COLOR_SUFFIX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Color Prefix Reducers
export const GetColorPrefixReducers = (
  state = {
    color_prefix: {},
  },
  action
) => {
  switch (action.type) {
    case GET_COLOR_PREFIX_REQUEST:
      return {
        loading: true,
      };
    case GET_COLOR_PREFIX_SUCCESS:
      return {
        ...state,
        loading: false,
        color_prefix: action.payload,
      };
    case GET_COLOR_PREFIX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// *****************************ADD PREFIX SUFFIX*************************************

// Get style Prefix Reducers
export const AddStylePrefixReducers = (
  state = {
    add_style_prefix: {},
  },
  action
) => {
  switch (action.type) {
    case ADD_STYLE_PREFIX_REQUEST:
      return {
        loading: true,
      };
    case ADD_STYLE_PREFIX_SUCCESS:
      return {
        ...state,
        loading: false,
        add_style_prefix: action.payload,
      };
    case ADD_STYLE_PREFIX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Style Suffix Reducers
export const AddStyleSuffixReducers = (
  state = {
    add_style_suffix: {},
  },
  action
) => {
  switch (action.type) {
    case ADD_STYLE_SUFFIX_REQUEST:
      return {
        loading: true,
      };
    case ADD_STYLE_SUFFIX_SUCCESS:
      return {
        ...state,
        loading: false,
        add_style_suffix: action.payload,
      };
    case ADD_STYLE_SUFFIX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Color Suffix Reducers
export const AddColorSuffixReducers = (
  state = {
    add_color_suffix: {},
  },
  action
) => {
  switch (action.type) {
    case ADD_COLOR_SUFFIX_REQUEST:
      return {
        loading: true,
      };
    case ADD_COLOR_SUFFIX_SUCCESS:
      return {
        ...state,
        loading: false,
        add_color_suffix: action.payload,
      };
    case ADD_COLOR_SUFFIX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Color Prefix Reducers
export const AddColorPrefixReducers = (
  state = {
    add_color_prefix: {},
  },
  action
) => {
  switch (action.type) {
    case ADD_COLOR_PREFIX_REQUEST:
      return {
        loading: true,
      };
    case ADD_COLOR_PREFIX_SUCCESS:
      return {
        ...state,
        loading: false,
        add_color_prefix: action.payload,
      };
    case ADD_COLOR_PREFIX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get PhotoShoot Data Reducers
export const GetPhotoshootDataReducers = (
  state = {
    photoshoot_data: {},
  },
  action
) => {
  switch (action.type) {
    case GET_PHOTOSHOOT_REQUEST:
      return {
        loading: true,
      };
    case GET_PHOTOSHOOT_SUCCESS:
      return {
        ...state,
        loading: false,
        photoshoot_data: action.payload,
      };
    case GET_PHOTOSHOOT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Export Template Reducers
export const ExportTemplateReducers = (
  state = {
    export_template: {},
  },
  action
) => {
  switch (action.type) {
    case EXPORT_TEMPLATE_REQUEST:
      return {
        loading: true,
      };
    case EXPORT_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        export_template: action.payload,
      };
    case EXPORT_TEMPLATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Create Session Reducers
export const CreateSessionReducers = (
  state = {
    create_Session: {},
  },
  action
) => {
  switch (action.type) {
    case CREATE_SESSION_REQUEST:
      return {
        loading: true,
      };
    case CREATE_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        create_Session: action.payload,
      };
    case CREATE_SESSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Session Reducers
export const getSessionReducers = (
  state = {
    Sessions: {},
  },
  action
) => {
  switch (action.type) {
    case GET_SESSION_REQUEST:
      return {
        loading: true,
      };
    case GET_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        Sessions: action.payload,
      };
    case GET_SESSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Update For Export Reducers
export const UpdateForExportStepReducers = (
  state = {
    update_Export: {},
  },
  action
) => {
  switch (action.type) {
    case UPDATE_FOR_EXPORT_STEP_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_FOR_EXPORT_STEP_SUCCESS:
      return {
        ...state,
        loading: false,
        update_Export: action.payload,
      };
    case UPDATE_FOR_EXPORT_STEP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Portal List Summary old Sku List Reducers
export const getportalListSummaryOldSkuListReducers = (
  state = {
    oldSku_List: {},
  },
  action
) => {
  switch (action.type) {
    case GET__OLD__SKU__LIST_REQUEST:
      return {
        loading: true,
      };
    case GET__OLD__SKU__LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        oldSku_List: action.payload,
      };
    case GET__OLD__SKU__LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Portal List Summary History Reducers
export const getPortalListSummaryHistoryReducers = (
  state = {
    summary_History: {},
  },
  action
) => {
  switch (action.type) {
    case GET__PORTAL_LIST__SUMMARY__HISTORY_REQUEST:
      return {
        loading: true,
      };
    case GET__PORTAL_LIST__SUMMARY__HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        summary_History: action.payload,
      };
    case GET__PORTAL_LIST__SUMMARY__HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Listing Quality Rating Reducers
export const getListingQualityRatingReducers = (
  state = {
    rating__quality: {},
  },
  action
) => {
  switch (action.type) {
    case GET__LISTING_QUALITY_RATING_REQUEST:
      return {
        loading: true,
      };
    case GET__LISTING_QUALITY_RATING_SUCCESS:
      return {
        ...state,
        loading: false,
        rating__quality: action.payload,
      };
    case GET__LISTING_QUALITY_RATING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Site Code Flipkart Inventory Reducers
export const getSiteCodeInventoryReducers = (
  state = {
    site_code_Inventory: {},
  },
  action
) => {
  switch (action.type) {
    case GET__SITE__CODES__INVENTORY_REQUEST:
      return {
        loading: true,
      };
    case GET__SITE__CODES__INVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        site_code_Inventory: action.payload,
      };
    case GET__SITE__CODES__INVENTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Add Cost Price Setting Reducers
export const AddCostPriceSettingReducers = (
  state = {
    add_cost_price__setting: {},
  },
  action
) => {
  switch (action.type) {
    case ADD__COST__PRICE__SETTING_REQUEST:
      return {
        loading: true,
      };
    case ADD__COST__PRICE__SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        add_cost_price__setting: action.payload,
      };
    case ADD__COST__PRICE__SETTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ADD__COST__PRICE__SETTING_RESET:
      return {
        ...state,
        loading: false,
        add_cost_price__setting: null,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Cost Price Setting Reducers
export const getCostPriceSettingReducers = (
  state = {
    cost_price__setting: {},
  },
  action
) => {
  switch (action.type) {
    case GET__COST__PRICE__SETTING_REQUEST:
      return {
        loading: true,
      };
    case GET__COST__PRICE__SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        cost_price__setting: action.payload,
      };
    case GET__COST__PRICE__SETTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Sizes Reducers
export const getSizesReducers = (
  state = {
    sizes: {},
    categories: {},
  },
  action
) => {
  switch (action.type) {
    case GET_SIZES_REQUEST:
    case GET_CATEGORIES_REQUEST:
      return {
        loading: true,
      };
    case GET_SIZES_SUCCESS:
      return {
        ...state,
        loading: false,
        sizes: action.payload,
      };
    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload,
      };
    case GET_SIZES_FAILURE:
    case GET_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Add Cost Group Reducers
export const AddCostGroupReducers = (
  state = {
    add_cost_group: {},
    iscost_group_deleted: {},
  },
  action
) => {
  switch (action.type) {
    case ADD_COST__GROUP_REQUEST:
      return {
        loading: true,
      };
    case DELETE__COST__GROUP_REQUEST:
      return {
        isCost_Group_DeleteLoading: true,
      };
    case ADD_COST__GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        add_cost_group: action.payload,
      };
    case DELETE__COST__GROUP_SUCCESS:
      return {
        ...state,
        isCost_Group_DeleteLoading: false,
        iscost_group_deleted: action.payload,
      };
    case ADD_COST__GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE__COST__GROUP_FAILURE:
      return {
        ...state,
        isCost_Group_DeleteLoading: false,
        error: action.payload,
      };
    case DELETE__COST__GROUP_RESET:
      return {
        ...state,
        isCost_Group_DeleteLoading: false,
        iscost_group_deleted: null,
      };
    case ADD_COST__GROUP_RESET:
      return {
        ...state,
        loading: false,
        add_cost_group: null,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Cost Group Summary Reducers
export const getCostGroupSummaryReducers = (
  state = {
    cost_group_summary: {},
  },
  action
) => {
  switch (action.type) {
    case GET__COST__GROUP__SUMMARY_REQUEST:
      return {
        loading: true,
      };
    case GET__COST__GROUP__SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        cost_group_summary: action.payload,
      };
    case GET__COST__GROUP__SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Price Band Summary Reducers
export const getPriceBandSummaryReducers = (
  state = {
    priceBand_summary: {},
  },
  action
) => {
  switch (action.type) {
    case GET_PRICE_BAND_REQUEST:
      return {
        loading: true,
      };
    case GET_PRICE_BAND_SUCCESS:
      return {
        ...state,
        loading: false,
        priceBand_summary: action.payload,
      };
    case GET_PRICE_BAND_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Save Price Band Reducers
export const SavePriceBandReducers = (
  state = {
    add_PriceBand: {},
  },
  action
) => {
  switch (action.type) {
    case SAVE_PRICE_BAND_REQUEST:
      return {
        loading: true,
      };
    case SAVE_PRICE_BAND_SUCCESS:
      return {
        ...state,
        loading: false,
        add_PriceBand: action.payload,
      };
    case SAVE_PRICE_BAND_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SAVE_PRICE_BAND_RESET:
      return {
        ...state,
        loading: false,
        add_PriceBand: null,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Product Sub Group Summary Reducers
export const GetProductSubGroupSummaryReducers = (
  state = {
    product__sub_groupSummary: {},
  },
  action
) => {
  switch (action.type) {
    case GET_SUB_GROUP_COST_SUMMARY_REQUEST:
      return {
        loading: true,
      };
    case GET_SUB_GROUP_COST_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        product__sub_groupSummary: action.payload,
      };
    case GET_SUB_GROUP_COST_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Add CAD Marker Reducers
export const AddCADMarkerReducers = (
  state = {
    save__CADMarker: {},
  },
  action
) => {
  switch (action.type) {
    case ADD_CAD__MARKER_REQUEST:
      return {
        loading: true,
      };
    case ADD_CAD__MARKER_SUCCESS:
      return {
        ...state,
        loading: false,
        save__CADMarker: action.payload,
      };
    case ADD_CAD__MARKER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ADD_CAD__MARKER_RESET:
      return {
        ...state,
        loading: false,
        save__CADMarker: null,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Price Component Reducers
export const GetPriceComponentReducers = (
  state = {
    price_component: {},
  },
  action
) => {
  switch (action.type) {
    case GET__PRICE__COMPONENT_REQUEST:
      return {
        loading: true,
      };
    case GET__PRICE__COMPONENT_SUCCESS:
      return {
        ...state,
        loading: false,
        price_component: action.payload,
      };
    case GET__PRICE__COMPONENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Cost Group Array Reducers
export const GetCostGroupArrayReducers = (
  state = {
    cost__group__Array: {},
  },
  action
) => {
  switch (action.type) {
    case GET__COST_GROUP_ARRAY_REQUEST:
      return {
        loading: true,
      };
    case GET__COST_GROUP_ARRAY_SUCCESS:
      return {
        ...state,
        loading: false,
        cost__group__Array: action.payload,
      };
    case GET__COST_GROUP_ARRAY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Update cost Price Details Reducers
export const UpdateCostPriceDetailsReducers = (
  state = {
    update__price__Details: {},
  },
  action
) => {
  switch (action.type) {
    case UPDATE__COST__PRICE__DETAILS_REQUEST:
      return {
        loading: true,
      };
    case UPDATE__COST__PRICE__DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        update__price__Details: action.payload,
      };
    case UPDATE__COST__PRICE__DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE__COST__PRICE__DETAILS_RESET:
      return {
        ...state,
        loading: false,
        update__price__Details: null,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Costing Summary Dropdown Reducers
export const CostingSummaryDropdownReducers = (
  state = {
    product__style__color: {},
    user__list: {},
  },
  action
) => {
  switch (action.type) {
    case GET_PRODUCT__STYLE__COLOR_REQUEST:
    case GET_USER__LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_USER__LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        user__list: action.payload,
      };
    case GET_PRODUCT__STYLE__COLOR_SUCCESS:
      return {
        ...state,
        loading: false,
        product__style__color: action.payload,
      };
    case GET_PRODUCT__STYLE__COLOR_FAILURE:
    case GET_USER__LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Product Group Details Reducers
export const getProductGroupDetailsReducers = (
  state = {
    product__group__details: {},
  },
  action
) => {
  switch (action.type) {
    case GET_PRODUCT__GROUP__DETAILS_REQUEST:
      return {
        loading: true,
      };
    case GET_PRODUCT__GROUP__DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        product__group__details: action.payload,
      };
    case GET_PRODUCT__GROUP__DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Cost Price Change Log Reducers
export const getCostPriceChangeLogReducers = (
  state = {
    cost_price__change_log: {},
  },
  action
) => {
  switch (action.type) {
    case GET__COST__PRICE__CHANGE__LOG_REQUEST:
      return {
        loading: true,
      };
    case GET__COST__PRICE__CHANGE__LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        cost_price__change_log: action.payload,
      };
    case GET__COST__PRICE__CHANGE__LOG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Price Component for Approve Reject Reducers
export const getPriceComponentForApproveRejectReducers = (
  state = {
    price__component__approveReject: {},
  },
  action
) => {
  switch (action.type) {
    case GET_PRICE_COMPONENT_FOR__APPROVE_REJECT_REQUEST:
      return {
        loading: true,
      };
    case GET_PRICE_COMPONENT_FOR__APPROVE_REJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        price__component__approveReject: action.payload,
      };
    case GET_PRICE_COMPONENT_FOR__APPROVE_REJECT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Master Group Data Reducers
export const getMasterGroupDataReducers = (
  state = {
    master__group__data: {},
  },
  action
) => {
  switch (action.type) {
    case GET_MASTER__GROUP_DATA_REQUEST:
      return {
        loading: true,
      };
    case GET_MASTER__GROUP_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        master__group__data: action.payload,
      };
    case GET_MASTER__GROUP_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Dropdown Data List Reducers
export const getDropdownDataListMasterGroupReducers = (
  state = {
    dropdown__data_listMaster__group: {},
  },
  action
) => {
  switch (action.type) {
    case GET_DROPDOWN_LIST_MASTER_GROUP_REQUEST:
      return {
        loading: true,
      };
    case GET_DROPDOWN_LIST_MASTER_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        dropdown__data_listMaster__group: action.payload,
      };
    case GET_DROPDOWN_LIST_MASTER_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Create Master Group Data Reducers
export const CreateMasterGroupDataReducers = (
  state = {
    is_Master_Data_created: {},
  },
  action
) => {
  switch (action.type) {
    case CREATE_MASTER_GROUP_DATA_REQUEST:
      return {
        loading: true,
      };
    case CREATE_MASTER_GROUP_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        is_Master_Data_created: action.payload,
      };
    case CREATE_MASTER_GROUP_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CREATE_MASTER_GROUP_DATA_RESET:
      return {
        ...state,
        loading: false,
        is_Master_Data_created: null,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Master Group Product List Reducers
export const GetMasterGroupProductListReducers = (
  state = {
    master_GroupProductList: {},
  },
  action
) => {
  switch (action.type) {
    case GET_MASTER_PRODUCT_GROUP_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_MASTER_PRODUCT_GROUP_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        master_GroupProductList: action.payload,
      };
    case GET_MASTER_PRODUCT_GROUP_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Add Remark Reducers
export const AddRemarkReducers = (
  state = {
    is_RemarkAdded: {},
  },
  action
) => {
  switch (action.type) {
    case ADD_REMARK_REQUEST:
      return {
        loading: true,
      };
    case ADD_REMARK_SUCCESS:
      return {
        ...state,
        loading: false,
        is_RemarkAdded: action.payload,
      };
    case ADD_REMARK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ADD_REMARK_RESET:
      return {
        ...state,
        loading: false,
        is_RemarkAdded: null,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Remark Reducers
export const GetRemarkReducers = (
  state = {
    remarks: {},
  },
  action
) => {
  switch (action.type) {
    case GET_REMARK_REQUEST:
      return {
        loading: true,
      };
    case GET_REMARK_SUCCESS:
      return {
        ...state,
        loading: false,
        remarks: action.payload,
      };
    case GET_REMARK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// View CAD Marker Reducers
export const ViewCADMarkerReducers = (
  state = {
    View_CAD: {},
  },
  action
) => {
  switch (action.type) {
    case VIEW_CAD_MARKER_REQUEST:
      return {
        loading: true,
      };
    case VIEW_CAD_MARKER_SUCCESS:
      return {
        ...state,
        loading: false,
        View_CAD: action.payload,
      };
    case VIEW_CAD_MARKER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Approve Reject Reducers
export const ApproveRejectCostPriceReducers = (
  state = {
    costPrice_approveReject: {},
  },
  action
) => {
  switch (action.type) {
    case APPROVE_REJECT_REQUEST:
      return {
        loading: true,
      };
    case APPROVE_REJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        costPrice_approveReject: action.payload,
      };
    case APPROVE_REJECT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case APPROVE_REJECT_RESET:
      return {
        ...state,
        loading: false,
        costPrice_approveReject: null,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Consumption Price History Reducers
export const GetConsumptionPricePriceHistoryReducers = (
  state = {
    consumptionPriceHistory: {},
  },
  action
) => {
  switch (action.type) {
    case GET_CONSUMPTION_PRICE_HISTORY_REQUEST:
      return {
        loading: true,
      };
    case GET_CONSUMPTION_PRICE_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        consumptionPriceHistory: action.payload,
      };
    case GET_CONSUMPTION_PRICE_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
